import React from 'react';
import { Link } from 'react-router-dom'; // Import Link from React Router
import { FaArrowDown } from 'react-icons/fa';
import { useFetch } from '../../hooks/useFetch';
import CardPackage from '../Package/CardPackage'; // Import CardPackage
import { t } from 'i18next';
import API_ENDPOINTS from '../../api';

// Function to get random packages
const getRandomPackages = (arr, num) => {
  const shuffled = [...arr].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, num);
};
 
const RandomPackage = () => {
  const { data: packages, loading, error } = useFetch(API_ENDPOINTS.PACKAGES.GET_ALL);
  const randomPackages = getRandomPackages(packages ? packages.packages : [], 3);
  // console.log(randomPackages);
  
  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto max-w-7xl">
        <header className="text-center mb-8 md:mb-12">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-primeColor mb-2 relative inline-block">
            {t("packages.title")}
            <span className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-24 h-1 rounded-full bg-secondColor"></span>
          </h2>
          <p className="text-lg text-gray-600  max-w-2xl mx-auto">
            {t("packages.description")}
          </p>
        </header>

        {/* Card Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 mb-8">
          {loading ? (
            <div className="col-span-full flex justify-center items-center py-12">
              <div className="flex flex-col items-center gap-4">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-secondColor"></div>
                <p className="text-gray-600">{t("packages.loading") || "Loading packages..."}</p>
              </div>
            </div>
          ) : error ? (
            <div className="col-span-full text-center py-12">
              <p className="text-red-500">{t("packages.error") || "Error loading packages"}</p>
            </div>
          ) : randomPackages.length > 0 ? (
            randomPackages.map((pkg, index) => (
              <div 
                key={pkg._id}
                className="animate-fadeIn"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <CardPackage packageData={pkg} />
              </div>
            ))
          ) : (
            <div className="col-span-full text-center py-12">
              <p className="text-gray-500 text-lg">{t("packages.noPackages")}</p>
            </div>
          )}
        </div>

        {/* Link to navigate to the package page */}
        <div className="flex justify-center mt-8">
          <Link 
            to="/package" 
            className="group no-underline text-primeColor-500  inline-flex items-center gap-2  hover:!bg-primeColor-500 hover:text-white transition-all duration-300 font-semibold text-base md:text-lg px-6 py-3 rounded-full border border-secondColor/40 hover:border-primeColor bg-white/70 hover:bg-white shadow-sm hover:shadow-md"
          >
            <span>{t("packages.home.more")}</span>
            <FaArrowDown className="transition-transform duration-300 group-hover:translate-y-1 animate-bounce" />
          </Link> 
        </div>
      </div>
    </section>
  );
};

export default RandomPackage;
